import { render } from "./Close.vue?vue&type=template&id=65d50cea&scoped=true"
import script from "./Close.vue?vue&type=script&lang=ts"
export * from "./Close.vue?vue&type=script&lang=ts"

import "./Close.vue?vue&type=style&index=0&id=65d50cea&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-65d50cea"

export default script